import React from 'react';
import { CardBody, CardTitle, Form, FormGroup, Row, Col, Label, Input } from 'reactstrap';
import PropTypes from 'prop-types';

import { InputState } from '../components';

const propTypes = {
  businessName: PropTypes.string,
  email: PropTypes.string,
  phone: PropTypes.string,
  street: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string,
  zip: PropTypes.string,
  suite: PropTypes.string,
  setBusinessName: PropTypes.func,
  setEmail: PropTypes.func,
  setPhone: PropTypes.func,
  setStreet: PropTypes.func,
  setCity: PropTypes.func,
  setState: PropTypes.func,
  setZip: PropTypes.func,
  setSuite: PropTypes.func,
};

const defaultProps = {
  businessName: '',
  email: '',
  phone: '',
  street: '',
  city: '',
  state: '',
  zip: '',
  suite: '',
  setBusinessName: undefined,
  setEmail: undefined,
  setPhone: undefined,
  setStreet: undefined,
  setCity: undefined,
  setState: undefined,
  setZip: undefined,
  setSuite: undefined,
};

const BusinessInfo = (props) => {
  const {
    businessName,
    email,
    phone,
    street,
    city,
    state,
    zip,
    suite,
    setBusinessName,
    setEmail,
    setPhone,
    setStreet,
    setCity,
    setState,
    setZip,
    setSuite,
  } = props;

  return (
    <div style={{ backgroundColor: '#f6f6f6' }}>
      <CardBody>
        <CardTitle>Business Info</CardTitle>
        <Form>
          <FormGroup>
            <Label>Business Name</Label>
            <Input
              bsSize="lg"
              value={businessName}
              onChange={e => setBusinessName(e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <Label>Email</Label>
            <Input bsSize="lg" value={email} onChange={e => setEmail(e.target.value)} />
          </FormGroup>
          <FormGroup>
            <Label>Phone Number</Label>
            <Input bsSize="lg" value={phone} onChange={e => setPhone(e.target.value)} />
          </FormGroup>
          <FormGroup>
            <Label>Address</Label>
            <Input bsSize="lg" value={street} onChange={e => setStreet(e.target.value)} />
          </FormGroup>
          <FormGroup>
            <Label>City</Label>
            <Input bsSize="lg" value={city} onChange={e => setCity(e.target.value)} />
          </FormGroup>
          <Row>
            <Col>
              <FormGroup>
                <Label>State</Label>
                <InputState
                  bsSize="lg"
                  value={state || 'placeholder'}
                  onChange={e => setState(e.target.value)}
                />
              </FormGroup>
            </Col>
            <Col>
              <FormGroup>
                <Label>Zip</Label>
                <Input bsSize="lg" value={zip} onChange={e => setZip(e.target.value)} />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col>
              <FormGroup>
                <Label>Suite</Label>
                <Input bsSize="lg" value={suite} onChange={e => setSuite(e.target.value)} />
              </FormGroup>
            </Col>
            <Col />
          </Row>
        </Form>
      </CardBody>
    </div>
  );
};

BusinessInfo.propTypes = propTypes;
BusinessInfo.defaultProps = defaultProps;

export { BusinessInfo };



// WEBPACK FOOTER //
// ./src/business/register/components/business-info.js